import DashboardTile from 'app/frontend/base/components/DashboardTile'
import { useGuild } from 'app/frontend/base/config/context/guild'
import { hasAccessToContent } from 'app/frontend/base/config/permissions'

const EntityLinksTile = ({
  className,
  uriLinkFragment,
}: {
  className?: string
  uriLinkFragment: string
}) => {
  const { guild, guildReference, currentTeam, teamReference } = useGuild()
  const guildInfo = guild || guildReference
  const canViewSpreadsheet = hasAccessToContent(
    'member',
    'base',
    guild,
    teamReference,
  ).hasAccess

  return (
    <DashboardTile
      className={className}
      innerClassName='h-8'
      title='links'
      dataPresent={true}
    >
      <div className='flex gap-2 justify-center min-w-30'>
        {canViewSpreadsheet && currentTeam?.spreadsheetPath ? (
          <a
            href={currentTeam.spreadsheetPath}
            target='_blank'
            rel='noreferrer'
          >
            <img
              src='https://data.wowaudit.com/img/sheets-logo.png'
              className='w-6 min-w-6'
            />
          </a>
        ) : null}
        {guildInfo?.blizzardUrl ? (
          <a href={guildInfo.blizzardUrl} target='_blank' rel='noreferrer'>
            <img
              src='https://data.wowaudit.com/img/wow-logo.png'
              className='w-6 min-w-6'
            />
          </a>
        ) : null}
        <a
          href={
            guildInfo?.wclUrl ||
            `https://www.warcraftlogs.com/guild/${uriLinkFragment}`
          }
          target='_blank'
          rel='noreferrer'
        >
          <img
            src='https://data.wowaudit.com/img/wcl-logo.png'
            className='w-6 min-w-6'
          />
        </a>
        {guildInfo?.raiderioUrl === null ? null : (
          <a
            href={
              guildInfo?.raiderioUrl ||
              `https://raider.io/guilds/${uriLinkFragment}`
            }
            target='_blank'
            rel='noreferrer'
          >
            <img
              src='https://data.wowaudit.com/img/raiderio-logo.png'
              className='w-6 min-w-6 border rounded-full'
            />
          </a>
        )}
      </div>
    </DashboardTile>
  )
}

export default EntityLinksTile
